import { principles, testimonials } from '@/mocks/homeData';

export default function Brand() {
  return (
    <section id="brand" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start mb-14 md:mb-20">
          <div className="lg:col-span-5">
            <span className="text-xs font-medium tracking-widest text-primary-600 uppercase">
              品牌介绍
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3 mb-4">
              爆料看点是什么
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                爆料看点是一个以"线索"为单位组织内容的信息整理站点。我们不追单条消息的时效，
                更在意一件事被放进同类事件之后，呈现出来的规律与差异。
              </p>
              <p>
                站内的每一条案例都会标注信息来源状态与核实进度，能交叉验证的写成结论，
                还停留在单方说法的只做记录。这样做的好处是，你在复盘时不会把不确定的细节当成既定事实。
              </p>
              <p>
                我们面向的是需要参照物的人：写稿前想找先例的创作者、分析行业变化的观察者、
                以及单纯想把一件事看到底的普通读者。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {principles.map((item) => (
                <div
                  key={item.title}
                  className="bg-background-100 border border-background-200 rounded-lg p-5"
                >
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 mb-4">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div>
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6 md:mb-8">
            使用者怎么说
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {testimonials.map((item) => (
              <figure
                key={item.name}
                className="bg-background-100 border border-background-200 rounded-lg p-6 flex flex-col"
              >
                <i className="ri-double-quotes-l text-3xl text-accent-400 mb-4"></i>
                <blockquote className="text-sm text-foreground-700 leading-relaxed flex-1">
                  {item.text}
                </blockquote>
                <figcaption className="mt-5 pt-4 border-t border-background-200">
                  <div className="text-sm font-medium text-foreground-950">{item.name}</div>
                  <div className="text-xs text-foreground-500 mt-0.5">{item.role}</div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}